import script from "./AgregarEtiquetaDialogComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AgregarEtiquetaDialogComponent.vue?vue&type=script&setup=true&lang=js"

import "./AgregarEtiquetaDialogComponent.vue?vue&type=style&index=0&id=f7a1b080&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7a1b080"]])

export default __exports__